import './Unauthorized.css';

import { SafetyOutlined, ArrowRightOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router';

function Unauthorized() {
    const navigate = useNavigate();

    return (
        <div className="unauthorized">
            <div className="unauthorized-background">
                <div className="unauthorized-container">
                    <div className="unauthorized-icon-container">
                        <SafetyOutlined className="unauthorized-icon" />
                    </div>
                    <h1>Unauthorized Access</h1>
                    <p>Access to this resource is restricted. Please log in with the appropriate credentials to continue.</p>
                    <p className="small-text">If you believe this is an error, please contact support.</p>
                    <button className="unauthorized-button" onClick={() => navigate('/login')}>
                        Go to Login <ArrowRightOutlined className="arrow-icon" />
                    </button>
                </div>
            </div>
        </div>
    );
}


export default Unauthorized;